// extracted by mini-css-extract-plugin
export default {"customField":"CustomExtendedDataField_customField__qwZyL","customLabel":"CustomExtendedDataField_customLabel__xxl1-"};